import { inject, Injectable } from '@angular/core';
import { TPartnerName } from '@partners/api';
import { SettingsMap } from '@partners/settings';
import { ShellStore } from '@partners/state';

@Injectable({
  providedIn: 'root'
})
export class PartnerUpdatesService {
  #shellStore = inject(ShellStore);
  #partnerName: TPartnerName;
  constructor() {
    const { partner } = this.#shellStore.params$$();
    this.#partnerName = partner;
  }
  /**
@description
* When hosted inside a webview the only way to inform the host app of anything from the html is by performing a (full) url update.
* Normally we only do that in the event of exiting partners (and returning to host app),
* in that scenario - the host app listens to our redirect (window.location.href), catches it and closes partners.
* HOWEVER - to inform the host app in other scenarios which does not require exiting the app - we cant do that.
* The only option to inform the host app of a url change from the html without existing partners via widow.location.href is to manipulate the browser's history stack, by "pushing" a url change event which the host app can detect.
*  We use HTML5 location & history api to do that
*/
  updatePartnerHistory() {
    if (!this.#partnerName) {
      return;
    }
    const partnerSettings = SettingsMap.partnerSettings(this.#partnerName);
    if (partnerSettings?.useHistoryForPartnerUpdates) {
      history.replaceState(null, window.location.href);
    }
  }
}
